<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="WalletToYouzan" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { WalletToYouzanProps } from './WalletToYozan.ts';
import WalletToYouzan from './WalletToYouzan.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-wallet-to-youzan';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<WalletToYouzanProps>();
const changableProps = useChangableProps(componentName, props);

</script>
